import classNames from 'classnames';
import * as React from 'react';
import { ILogState } from 'source/app/presentation/MainPanel/Log/ILogState';
import { HandleAddLogEntryChange } from 'source/app/presentation/MainPanel/Log/LogInputForm/LogInputFormHelpers';
import { FormInput } from 'source/app/presentation/Shared/Form/Input/FormInput';
import { StyleClass } from 'source/app/presentation/Shared/Styles/CSS';
import { AddNewEntry } from 'source/app/services/Log/AddEntry';
import { ESharedComponent } from 'source/app/services/UI/State/ESharedComponent';
import { State } from 'source/app/services/UI/State/State';
import { Defocus, LogInputForm, OnLogInputFormControlFocus } from '../LogInputForm';

export function LogInputEntryText({
	logInputForm
}: {
	logInputForm: LogInputForm;
}) {
	const { props, state } = logInputForm;

	const textAlignCenterStyleClass = StyleClass(`centerText`, {
		textAlign: `center`
	});

	const entryText = props.logState.LogInpEntryText;

	const shouldShowClearIcon =
		IsLogInputEntryTextTooShort(entryText) && entryText !== '';

	return (
		<FormInput
			id="target_logInputEntryText"
			width={state.filterGoalCards ? '80%' : '50%'}
			type="text"
			placeholder={state.filterGoalCards ? 'Enter goal name' : 'Entry'}
			value={entryText}
			suggestions={props.logState.goalNames}
			onChange={HandleLogInputEntryTextChange}
			classes={classNames([ textAlignCenterStyleClass ])}
			onClear={shouldShowClearIcon ? HandleClear : undefined}
			onEnter={async () => await AddNewEntry(logInputForm.props.logState)}
			onFocus={() => OnLogInputFormControlFocus()}
			onDefocus={() => Defocus()}
			dynamicOpacity
		/>
	);
}

export function IsLogInputEntryTextTooShort(entryText: string) {
	return entryText.length < minimumLogInputEntryTextLength;
}

const HandleLogInputEntryTextChange = (
	event: React.ChangeEvent<HTMLInputElement>
) => {
	const entryText = event.target.value;
	HandleAddLogEntryChange('LogInpEntryText', entryText);
};

function HandleClear() {
	const log = State.ReadClass<ILogState>(ESharedComponent.Log);

	if (log) {
		log.setState({ LogInpEntryText: '' });
	}
}

export const minimumLogInputEntryTextLength = 3;
